<div>
  @if (count) {
    <span>
      {{ count }} Capture{{ count > 1 ? 's' : '' }}
    </span>
  } @else {
    <span>Loading...</span>
  }
  <span> | </span>
  <a class="text-danger reset-filters"
    href="#"
  (click)="onResetFiltersClick($event)">Reset Filters</a>
</div>
